import { render, staticRenderFns } from "./Conversations.vue?vue&type=template&id=6445a252&scoped=true"
import script from "./Conversations.vue?vue&type=script&lang=js"
export * from "./Conversations.vue?vue&type=script&lang=js"
import style0 from "./Conversations.vue?vue&type=style&index=0&id=6445a252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6445a252",
  null
  
)

export default component.exports